module.exports = __webpack_public_path__ + "img/oval-auth-password.78b36c66.svg";